import { render, staticRenderFns } from "./ToggleStaffChat.vue?vue&type=template&id=f887f374&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ToggleStaffChat.vue?vue&type=script&lang=js"
export * from "./ToggleStaffChat.vue?vue&type=script&lang=js"
import style0 from "./ToggleStaffChat.vue?vue&type=style&index=0&id=f887f374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f887f374",
  null
  
)

export default component.exports